// extracted by mini-css-extract-plugin
module.exports = {"root":"_4FQkhsg5","heading":"ZmayVzk6","recaptcha-container":"kLvHt0Ge"};